module.exports = __webpack_public_path__ + "static/media/ActionPlanBanner.dbcf0e79.svg";